document.addEventListener('DOMContentLoaded', () => {
  const dealersLists = document.querySelectorAll('.dealers-list')

  if (dealersLists) {
    dealersLists.forEach(dealersList => {
      const items = dealersList.querySelectorAll('.dealers-list__item')
      let timeout
      const resize = () => {
        clearTimeout(timeout)
        timeout = setTimeout(() => {
          dealersList.innerHTML = ''
          let columns = Math.floor(dealersList.clientWidth / 355)
          columns = columns > 0 ? columns : 1
          dealersList.style.setProperty('--columns', columns)
          for(let i = 0; i < columns; i++) {
            const dealerWrapper = document.createElement('div')
            dealerWrapper.classList.add('dealers-list__wrapper')
            dealersList.appendChild(dealerWrapper)
            for(let j = i; j < items.length; j = j + columns) {
              if(items[j]) {
                dealerWrapper.appendChild(items[j])
              }
            }
          }
        }, 200)
      }

      window.addEventListener('resize', resize)
      resize()
    })
  }
})
